const { createSlice } = require("@reduxjs/toolkit");


const eksplodeSlice = createSlice({
    name: 'Eksplode Member',
    initialState:{
        user: {},
        adCards:[
            // {
            //     bookId: 'BK003',
            //     bookTitle: 'The Dreaming Arts',
            //     created: '3 March, 2021',
            //     expiry: '3 April, 2021'
            // },
            // {
            //     bookId: 'BK456',
            //     bookTitle: 'How to Follow your Heart',
            //     created: '25 July, 2021',
            //     expiry: '4 Aug, 2021'
            // }
        ],
        notifications:[
            {
                title: 'AdCard Expired',
                message: 'Ad Card Card Expired on 15 Aug, 2021',
                date: '14 Aug, 2021'
            },
        ]
    },
    reducers:{
        fetchMember: (state, action) => {
            // console.log({'Fetch Eksplode Member Action Payload': action.payload})
            state.user = action.payload
        }

    }
})

export const {fetchMember} = eksplodeSlice.actions
export default eksplodeSlice.reducer